( function () {
    'use strict';
    e.searching = {
        init: function () {
            if ( e.util.param.q !== undefined ) {
                //hvis der bliver s&oslash;gt sættes cursoren i s&oslash;gefeltet
                jQuery( '.form-search' ).first().find( 'input[name="q"]' ).focus().select();
                if ( !isNaN( parseInt( e.util.param.searchpage ) ) ) {
                    jQuery( '.e-search, .form-search, .navbar-search' ).find( 'input[name="ID"]' ).val( e.util.param.searchpage );
                }
            }
            e.searching.buildPaging();
            e.searching.suggest.loadIndex();
        },
        suggest: {
            loadIndex: function () {
                jQuery.ajax( {
                    url: '/json-suggested-search',
                    data: {
                        q: 'load-index',
                    }
                } ).success( e.searching.suggest.init );
            },
            init: function () {
                //console.log( 'suggest init' );
                jQuery( '.js-e-suggest' ).prop( 'autocomplete', 'off' ).typeahead( {
                    menu: '<ul class="typeahead nav dropdown-menu js-e-typeahead-dropdown"></ul>',
                    minLength: 3,
                    items: 8,
                    source: function ( query, process ) {
                        return jQuery.ajax( {
                            url: '/json-suggested-search',
                            data: {
                                q: query,
                                limit: 8
                            },
                            dataType: 'json',
                        } ).done( function ( data ) {
                            e.searching.suggest.pages = [];
                            e.searching.suggest.pageMap = {};
                            jQuery.each( data.results, function ( index, page ) {
                                e.searching.suggest.pageMap[ page.header ] = page;
                                //console.log( page.title );
                                e.searching.suggest.pages.push( page.header );
                            } );
                            if ( e.searching.suggest.pages.length > 0 ) {
                                //Skjul fejlbesked
                                //e.ecom.quick.jOrderForm.find( '.js-e-msg-no-result' ).hide();
                            }
                            return process( e.searching.suggest.pages );
                        } );
                    },
                    render: function ( items ) {
                        var that = this;
                        items = $( items ).map( function ( i, item ) {
                            i = $( that.options.item ).attr( 'data-value', item );
                            i.find( 'a' ).html( that.highlighter( item ) );
                            return i[ 0 ];
                        } );
                        //items.first().addClass( 'active' );
                        this.$menu.html( items );
                        return this;
                    },
                    sorter: function ( items ) {
                        //console.log( items.length );
                        return items;
                    },
                    matcher: function () {
                        return true;
                    },
                    updater: function ( item ) {
                        location.href = e.searching.suggest.pageMap[ item ].url;
                        return this.query;
                    }
                } );
            }
        },
        buildPaging: function () {
            //byg bootstrap markup af dw's default paging
            var jSearchPaging = jQuery( '.pagination' );
            if ( jSearchPaging.length === 1 ) {
                jQuery( '.page-list a' ).wrap( function () {
                    var jListItem = jQuery( '<li></li>' );
                    if ( jQuery( this ).find( 'b' ).length > 0 ) {
                        return jListItem.addClass( 'active' );
                    }
                    else {
                        return jListItem;
                    }
                } );
                jSearchPaging.find( 'li' ).first().after( jQuery( '.page-list li' ) );
            }
        }
    };
}() );
